import { render, staticRenderFns } from "./BrokerPresentationView.vue?vue&type=template&id=08e4cfc6"
import script from "./BrokerPresentationView.vue?vue&type=script&lang=js"
export * from "./BrokerPresentationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports